<template>
  <div class="left-sidebar">
    <slot name="sidebar-operation">
      <sidebar-operation />
    </slot>
    <slot name="sidebar-avatar">
      <sidebar-avatar />
    </slot>
    <sidebar-module :activeName="activeName" @handleActive="handleActive" />
    <sidebar-module :activeName="activeName" moduleName="mailList" :icon="'ukfont youkai-tongxunlu2 module-active'" :unActiveIcon="'ukfont youkai-tongxunlu'" @handleActive="handleActive" />
    <div style="margin-top: auto; margin-bottom: 1rem">
      <i style="font-size: 24px; cursor: pointer" class="el-icon-s-tools" @click="handleSetIng"></i>
    </div>
  </div>
</template>

<script>
import SidebarOperation from './SidebarOperation'
import SidebarAvatar from './SidebarAvatar'
import SidebarModule from './SidebarModule'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ImLeftSidebar',
  components: { SidebarOperation, SidebarAvatar, SidebarModule },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      activeName: state => state.imLeftActiveName,
      imActiveAccount: state => state.imActiveAccount,
      imAccount: state => state.imAccount,
      imSessionMap: state => state.imSessionMap
    })
  },
  watch: {
    activeName (val) {
      if (val === 'chat' && this.imActiveAccount && this.imActiveAccount.id && this.imActiveAccount.id !== '7380252502656237619') {
        const session = this.imSessionMap[this.imActiveAccount.id]
        if (session.unread > 0) this.$store.dispatch('reduceImUnreadCountAction', session.unread)
        this.imActiveChange({ session: session, scene: this.imActiveAccount.scene, to: this.imActiveAccount.to, messageListScrollTot: 'bottom', imAccId: this.imAccount.im_accid })
      } else if (val !== 'chat' && this.imActiveAccount && this.imActiveAccount.id && this.imActiveAccount.id !== '7380252502656237619') {
        this.resetCurrSession(this.imActiveAccount)
      }
    }
  },
  methods: {
    ...mapActions(['resetCurrSession', 'imActiveChange']),
    changeFullscreen () {
      this.fullscreen = !this.fullscreen
    },
    imWindowClose () {
      console.log('imUnreadCount', this.$store.state.imUnreadCount)
      this.$store.dispatch('showImWindowStoreAction', false)
    },
    handleActive (val) {
      this.$store.commit('changeImLeftActiveNameStoreMutation', val)
    },
    handleSetIng () {
      this.$store.dispatch('changeImSetWinVisibleAction', true)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .left-sidebar {
    display: flex;
    width: 60px;
    height: 100%;
    border-right: 1px solid #e8e8e8;
    flex-direction: column;
    align-items: center;
    position: relative;
    background-color: rgba(211, 211, 211, .7);
  }
</style>



// WEBPACK FOOTER //
// src/common/im/leftSidebar/ImLeftSidebar.vue